// extracted by mini-css-extract-plugin
module.exports = {"container":"link_container__80Fm5"};